module.exports = __webpack_public_path__ + "static/media/benefit-access-green.83aafdd1.svg";